import { useEffect } from 'react';
import * as Actions from '../../store/actions';
import { useDispatch } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import RoutesPage from "../../Routes";

const CoreRouter = () => {

  const dispatch = useDispatch();
  useEffect(() => {
    const storedJwt = localStorage.getItem('token');
    if (storedJwt) {
      dispatch(Actions.isAuth(true));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <Router>
      <RoutesPage />
    </Router>
  );
}

export default CoreRouter;